<template>
  <div v-if="published">
    <div class="container-fluid">
      <div class="row">
        <div class="col-6">
          <div class="row text-bold h1" v-html=entry.title></div>
          <hr>
          <div class="row" v-html=entry.summary></div>
        </div>
        <hr>
        <div class="col-6">
          <img :src="entry.image" style="height: 30vh;">
        </div>
      </div>
      <div class="row" v-html=entry.text ></div>
    </div>


  </div>
  <div v-else class="search-panel-collapse" v-bind="panels">
    <div class="search-panel-button">
      <b-button v-b-toggle.collapse-1 variant="info">Toggle Taxon Search Panels</b-button>
    </div>

    <b-collapse visible id="collapse-1" class="mt-2">
      <b-card class="search-panels">
        <TaxonSelectorPanel v-on:remove-panel="removeTaxonSelectorPanel" v-for="panel in panels"
                            v-bind:key="panel.panelId" :backgroundColor="panel.backgroundColor"
                            :panelId="panel.panelId" :removable="panels.length> 1"
                            :settings="panel"></TaxonSelectorPanel>
        <div class="search-panel-button">
          <b-button variant="info" v-on:click="addNewTaxonSelectorPanel">Add Taxon Search Panel</b-button>
        </div>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
/* eslint-disable */
import {mapActions, mapGetters, mapMutations} from "vuex";
import TaxonSelectorPanel from "./TaxonSelectorPanel";
import {guid} from '../store/lib';

export default {
  name: "SearchPanel",
  components: {
    TaxonSelectorPanel
  },
  data() {
    return {
      colorList: ["#047D72", "#e8860e", "#6FC079", "#F9F871", "#946F5C", "#7E3A64", "#882100"],
      colorIndex: 0,
      triggerValue: 0,
    }
  },
  props: ["dashId", "published", "entry"],


  computed: {
    ...mapGetters([
      'getPanelList',

    ]),

    panels() {
      return this.getPanelList
    }

  },

  created() {
    this.addNewTaxonSelectorPanel();
  },

  methods: {

    ...mapActions([
      'addTaxonSelectorPanel',
      'removeTaxonSelectorPanelWithDependencies'

    ]),

    addNewTaxonSelectorPanel: function () {
      let colorIndex = this.colorIndex % this.colorList.length
      let color = this.colorList[colorIndex]
      let id = guid()
      this.colorIndex += 1
      this.addTaxonSelectorPanel({'panelId': id, 'backgroundColor': color, 'name': 'Unnamed Panel', 'restore': false})
    },

    removeTaxonSelectorPanel(panelId) {
      this.removeTaxonSelectorPanelWithDependencies(panelId)
    },

  }
}

</script>

<style scoped>
html {
  text-align: center;
}

.panel {
  background: #edf3f7 !important;
}

.card-header-custom {
  background-color: rgba(0, 0, 0, .03);
}

.search-panel-collapse {
  padding-top: 8px;
  padding-left: 2px;
  padding-right: 2px;
  border-color: #005B60;
  border-width: 2px;
  border-style: solid;

}

.search-panel-button {
  width: 100%;
  text-align: left;
  margin-left: 4px;
  padding-top: 4px;
}

</style>